import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import store from "redux/store";
import {
  GET_ADDBOOKING,
  GET_AIRPORTTERMINALLIST,
  GET_BOOKINGBUFFERTIME,
  GET_BOOKINGDETAILS,
  GET_BOOKINGLIST,
  GET_CANCELREASSON,
  GET_COMPANYCITY,
  GET_COMPANYSERVICE,
  GET_UPDATEBOOKING,
} from "resources/actionTypes";
import {
  getBookingListService,
  getBookingDetailsService,
  addBookingService,
  updateBookingService,
  getCancelReasonService,
  getBookingBufferTimeService,
  getCompanyCityService,
  getCompanyServiceService,
  getAirportTerminalListService,
} from "services/ReservationService";
import { getBookingList } from "redux/actions/ReservationAction";
import { onLoaderTrigger } from "redux/actions/commonAction";
import { getCar } from "redux/actions/UserCar";

function* fetchGetBookingList(action) {
  const payload = action.payload || {};
  const bookingList = yield call(getBookingListService, payload);
  if (bookingList.success) {
    yield put({
      type: GET_BOOKINGLIST.GET_BOOKINGLIST_SUCCESS,
      bookingList: bookingList,
    });
  } else {
    yield put({
      type: GET_BOOKINGLIST.GET_BOOKINGLIST_FAILED,
      message: bookingList.message,
    });
    toast.error(bookingList.message || "fetching Booking List Failed");
  }
}

export function* getBookingListWatcher() {
  yield takeEvery(
    GET_BOOKINGLIST.GET_BOOKINGLIST_REQUESTED,
    fetchGetBookingList
  );
}

function* fetchGetBookingDetails(action) {
  const payload = action.payload || {};
  const bookingDetails = yield call(getBookingDetailsService, payload);
  if (bookingDetails.success) {
    yield put({
      type: GET_BOOKINGDETAILS.GET_BOOKINGDETAILS_SUCCESS,
      bookingDetails: bookingDetails?.data,
    });
  } else {
    yield put({
      type: GET_BOOKINGDETAILS.GET_BOOKINGDETAILS_FAILED,
      message: bookingDetails.message,
    });
    toast.error(bookingDetails.message || "Fetching Booking Details Failed");
  }
}

export function* getBookingDetailsWatcher() {
  yield takeEvery(
    GET_BOOKINGDETAILS.GET_BOOKINGDETAILS_REQUESTED,
    fetchGetBookingDetails
  );
}

function* fetchAddBooking(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const addBooking = yield call(addBookingService, payload.bookingData);

  if (addBooking.success) {
    yield put({
      type: GET_ADDBOOKING.GET_ADDBOOKING_SUCCESS,
      addBookingResponse: addBooking,
    });
    toast.success(addBooking.message);
    store.dispatch(onLoaderTrigger(false));
    payload.setConfirmModal();
  } else {
    yield put({
      type: GET_ADDBOOKING.GET_ADDBOOKING_FAILED,
      message: addBooking.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(addBooking.message || "Add Booking Failed");
  }
}

export function* addReservationSaga() {
  yield takeEvery(GET_ADDBOOKING.GET_ADDBOOKING_REQUESTED, fetchAddBooking);
}

function* fetchPatchBooking(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const addBooking = yield call(updateBookingService, payload);
  if (addBooking.success) {
    yield put({
      type: GET_UPDATEBOOKING.GET_UPDATEBOOKING_SUCCESS,
      addBookingResponse: addBooking,
    });
    toast.success(addBooking?.message);
    store.dispatch(onLoaderTrigger(false));
    if (payload.navigate === undefined) {
      const payloadData = {
        search: "",
        page: "",
        pageSize: "",
        dateFrom: "",
        dateTo: "",
        status: "",
      };
      store.dispatch(getBookingList(payloadData));
    } else {
      payload.navigate("/front-desk/all");
    }
  } else {
    yield put({
      type: GET_UPDATEBOOKING.GET_UPDATEBOOKING_FAILED,
      message: addBooking.message,
    });
    store.dispatch(onLoaderTrigger(false));
      toast.error(addBooking.message || "Updating Reservation Failed");
  }
}

export function* UpdateReservationSaga() {
  yield takeEvery(GET_UPDATEBOOKING.GET_UPDATEBOOKING_REQUESTED, fetchPatchBooking);
}

function* fetchGetCancelReason(action) {
  const payload = action.payload || {};
  const cancelReason = yield call(getCancelReasonService, payload);
  if (cancelReason.success) {
    yield put({
      type: GET_CANCELREASSON.GET_CANCELREASSON_SUCCESS,
      cancelReason: cancelReason,
    });
  } else {
    yield put({
      type: GET_CANCELREASSON.GET_CANCELREASSON_FAILED,
      message: cancelReason.message,
    });
    toast.error(cancelReason.message || "fetching Reason List Failed");
  }
}

export function* getCancelReasonWatcher() {
  yield takeEvery(
    GET_CANCELREASSON.GET_CANCELREASSON_REQUESTED,
    fetchGetCancelReason
  );
}

//get pre booking buffer time
function* getBookingBufferTime(action) {
  const payload = action.payload || {};
  const bufferTime = yield call(getBookingBufferTimeService, payload);
  if (bufferTime.success) {
    yield put({
      type: GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_SUCCESS,
      bufferTime: bufferTime,
    });
  } else {
    yield put({
      type: GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_FAILED,
      message: bufferTime.message,
    });
    toast.error(bufferTime.message || "Fetching Booking Buffer Time Failed");
  }
}

export function* getBookingBufferTimeWatcher() {
  yield takeEvery(
    GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_REQUESTED,
    getBookingBufferTime
  );
}

//get company city
function* getCompanyCity(action) {
  const payload = action.payload || {};
  const companyCity = yield call(getCompanyCityService, payload);
  if (companyCity.success) {
    yield put({
      type: GET_COMPANYCITY.GET_COMPANYCITY_SUCCESS,
      companyCity: companyCity,
    });
  } else {
    yield put({
      type: GET_COMPANYCITY.GET_COMPANYCITY_FAILED,
      message: companyCity.message,
    });
    toast.error(companyCity.message || "Fetching Company city list Failed");
  }
}

export function* getCompanyCityWatcher() {
  yield takeEvery(
    GET_COMPANYCITY.GET_COMPANYCITY_REQUESTED,
    getCompanyCity
  );
}

//get company service
function* getCompanyService(action) {
  const payload = action.payload || {};
  const companyService = yield call(getCompanyServiceService, payload?.data);
  
  if (companyService.success) {
    yield put({
      type: GET_COMPANYSERVICE.GET_COMPANYSERVICE_SUCCESS,
      companyService: companyService,
    });

    if(payload?.type) {
      const payloadData = {
       ...payload?.data,
       type: companyService?.data?.[0]?.tripType,
      }

      const dutyType = companyService?.data?.map((val) => ({
        id: val.tripType,
        name: val.name,
      }));

      const filterValues = {
        ...payload?.filterValues,
        dutyType: dutyType?.[0]
      }

      payload?.setFilterValues(filterValues);
      store.dispatch(getCar(payloadData, "ratecard", payload?.setFilterValues, filterValues))
    }
  } else {
    yield put({
      type: GET_COMPANYSERVICE.GET_COMPANYSERVICE_FAILED,
      message: companyService.message,
    });
    toast.error(companyService.message || "Fetching Company service list Failed");
  }
}

export function* getCompanyServiceWatcher() {
  yield takeEvery(
    GET_COMPANYSERVICE.GET_COMPANYSERVICE_REQUESTED,
    getCompanyService
  );
}

//get airport Terminal list
function* getAirportTerminalList(action) {
  const payload = action.payload || {};
  const airportListDetails = yield call(getAirportTerminalListService, payload);
  if (airportListDetails.success) {
    yield put({
      type: GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_SUCCESS,
      airportTerminalsDetails: airportListDetails,
    });
  } else {
    yield put({
      type: GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_FAILED,
      message: airportListDetails.message,
    });
    toast.error(airportListDetails?.message || "Fetching Airport Terminal List Failed");
  }
}

export function* getAirportTerminalListWatcher() {
  yield takeEvery(
    GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_REQUESTED,
    getAirportTerminalList
  );
}